import React from 'react'
import { BsQuestionCircle } from 'react-icons/bs'
import { useSelector } from 'react-redux'
import {
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row
} from 'reactstrap'
import { ApplicationState } from 'store'
import { KANBAN } from 'store/modules/kanban/types'
import { CustomButton, SimpleTitleCard } from 'styles/global'
import * as kanbanActions from 'store/modules/kanban/actions'
import useRedux from 'hooks/useRedux'
import { maskCPF } from 'util/masks'

const ModalConfirmacao = () => {
  const { modalConfirmacao, modalCpf } = useSelector<ApplicationState, KANBAN>(
    (state) => state.kanban
  )

  const { dispatch } = useRedux()

  function toggleModal() {
    dispatch(kanbanActions.setIsOpenModalConfirmacao(!modalConfirmacao.isOpen))
  }

  function confirmarCadastramento() {
    dispatch(kanbanActions.setIsOpenModalCadastroCliente(true))
    dispatch(kanbanActions.cleanInvalidsRegisterModalCadastroCliente())
    dispatch(
      kanbanActions.setRegisterModalCadastroClienteField(
        maskCPF(modalCpf.cpf),
        'cpf'
      )
    )
    dispatch(kanbanActions.setIsOpenModalCpf(false))
    dispatch(kanbanActions.setIsOpenModalConfirmacao(false))
    toggleModal()
  }
  return (
    <Modal isOpen={modalConfirmacao.isOpen} toggle={() => toggleModal()}>
      <ModalBody>
        <ModalHeader toggle={() => toggleModal()}>
          <SimpleTitleCard>
            <BsQuestionCircle className="icon" />
            Cliente não encontrado
          </SimpleTitleCard>
        </ModalHeader>
        <Row className="d-flex my-4 row-gap-15">
          <Col>
            <label>Deseja cadastrar um novo cliente?</label>
          </Col>
        </Row>
        <ModalFooter className="d-flex justify-content-center">
          <Row className="d-flex column-gap-20">
            <CustomButton onClick={() => toggleModal()} background="#662D91">
              Cancelar
            </CustomButton>
            <CustomButton onClick={() => confirmarCadastramento()}>
              Cadastrar
            </CustomButton>
          </Row>
        </ModalFooter>
      </ModalBody>
    </Modal>
  )
}

export default ModalConfirmacao
